// extracted by css-extract-rspack-plugin
export default {"badge":"badge-nYtIca","high":"high-sZqehl","medium":"medium-B9n1jG","low":"low-sQZwhL","neutral":"neutral-b8dclv"};